function startTimer() {
    const currentTime = new Date().getTime();
    const initialSeconds = getInitialTimerSeconds();
    const storedEndTime = sessionStorage.getItem("endTime");
    const storedEndTimeValue = storedEndTime ? parseInt(storedEndTime) : null;
    const maxEndTime = currentTime + initialSeconds * 1000;
    const endTime = storedEndTimeValue && storedEndTimeValue <= maxEndTime ? storedEndTimeValue : maxEndTime;
    sessionStorage.setItem("endTime", endTime);
  
    if (currentTime > endTime) {
      displayTimeLeft(0);
    } else {
      let remainingSeconds = Math.round((endTime - currentTime) / 1000);
      displayTimeLeft(remainingSeconds);
      setInterval(() => {
        remainingSeconds = Math.max(0, --remainingSeconds);
        displayTimeLeft(remainingSeconds);
      }, 1000);
    }
  }
  
  function getInitialTimerSeconds() {
    const timerElement = document.getElementById("timer");
    const timerText = timerElement ? timerElement.textContent : "4:58";
    const [minutes, seconds] = timerText.split(":").map(Number);
    return (Number.isFinite(minutes) ? minutes : 4) * 60 + (Number.isFinite(seconds) ? seconds : 58);
  }
  
  function displayTimeLeft(seconds) {
    const minutes = Math.floor(seconds / 60);
    const formattedTime = `${minutes}:${("0" + (seconds % 60)).slice(-2)}`;
    document.getElementById("timer").textContent = formattedTime;
  }
  
  $(document).ready(function () {
    $(".tpl-marquee__init").each(function () {
      $(this).marquee({
        delayBeforeStart: 0,
        duplicated: true,
        startVisible: true,
      });
    });
  
    $(".tpl-js-scroller").on("click", function (event) {
      event.preventDefault();
      const targetSelector = $(this).attr("href");
      const scrollTarget = $(targetSelector).offset().top - 20;
  
      if ($(".tpl__js-open-menu-btn").hasClass("tpl__is-active")) {
        $(".tpl__js-open-menu-btn").removeClass("tpl__is-active");
        $(".tpl-header").removeClass("tpl__is-active");
        $(".tpl-nav").removeClass("tpl__is-active");
        $("html").removeClass("tpl__is-fixed");
      }
  
      $("html, body").animate({ scrollTop: scrollTarget }, 450);
    });
  
    $(".tpl__js-open-menu-btn").on("click", function (event) {
      event.preventDefault();
      $(this).toggleClass("tpl__is-active");
      $(".tpl-header").toggleClass("tpl__is-active");
      $(".tpl-nav").toggleClass("tpl__is-active");
      $("html").toggleClass("tpl__is-fixed");
    });
  
    // Случайные имена и суммы
    let randomEntries = [
      ["Ал***** Т.А", "42 000 ₽"],
      ["Да***** А.С", "37 000 ₽"],
      ["Ни***** С.Ф", "56 000 ₽"],
      ["Та***** Н.Н", "40 000 ₽"],
      ["Ге***** Г.С", "50 000 ₽"],
      ["Ал***** М.А", "52 000 ₽"],
    ];
  
    // Перемешивание
    (function shuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const randomIndex = Math.floor(Math.random() * (i + 1));
        [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
      }
    })(randomEntries);
  
    $(".tpl-request-info__name").each(function (index) {
      $(this).text(randomEntries[index][0]);
    });
  
    $(".tpl-request-info__price").each(function (index) {
      $(this).text(randomEntries[index][1]);
    });
  
    // Рейтинг
    if ($(".tpl-rating-value").length > 0) {
      const randomRating = Math.round((Math.random() * 0.2 + 4.7) * 10) / 10;
      $(".tpl-rating-value").text(randomRating);
    }
  
    if ($(".tpl-rating-quantity span").length > 0) {
      const randomRatingCount = Math.floor(Math.random() * 90) + 60;
      $(".tpl-rating-quantity span").text(randomRatingCount);
    }
  
    $(".tpl-offer__rating-value_dynamic").each(function () {
      const dynamicRating = Math.round((Math.random() * 0.2 + 4.7) * 10) / 10;
      $(this).text(dynamicRating);
    });
  
    if ($(".tpl-popup-loader__text").length > 0) {
      setTimeout(() => {
        $(".tpl-popup-loader").fadeOut();
      }, 6800);
  
      const loaderSteps = [
        "Проверка КИ...",
        "Проверка по ФССП...",
        "Проверка скорингового балла...",
        "",
      ];
  
      function runLoaderStep(stepIndex) {
        if (loaderSteps[stepIndex] === undefined) {
          setTimeout(() => runLoaderStep(0), 10000);
          return;
        }
  
        function typeLine(text, charIndex, callback) {
          if (charIndex < text.length) {
            document.querySelector(".tpl-popup-loader__text").innerHTML =
              text.substring(0, charIndex + 1) + '<span aria-hidden="true"></span>';
            setTimeout(() => typeLine(text, charIndex + 1, callback), 70);
          } else if (typeof callback === "function") {
            setTimeout(callback, 500);
          }
        }
  
        typeLine(loaderSteps[stepIndex], 0, () => runLoaderStep(stepIndex + 1));
      }
  
      runLoaderStep(0);
    }
  
    $(".tpl__js-close-popup-btn").on("click", function (event) {
      event.preventDefault();
      $(this).parents(".tpl__js-popup").fadeOut(300);
      $("html").removeClass("tpl__is-fixed");
    });
  
    $(".tpl-popup__overflow").on("click", function (event) {
      event.stopPropagation();
      const popupBody = $(this).find(".tpl-popup__body");
      if (!popupBody.is(event.target) && popupBody.has(event.target).length === 0) {
        $("html").removeClass("tpl__is-fixed");
        $(".tpl__js-popup").fadeOut(300);
      }
    });
  });
  
  $(window).on("load", function () {
    if ($(".tpl__js-popup").length > 0) {
      setTimeout(() => {
        $("html").addClass("tpl__is-fixed");
        $(".tpl__js-popup").fadeIn(350);
      }, 12000);
    }
  });
  
  startTimer();